import { Block } from 'shared/components/Block';
import { Wrapper } from 'shared/components/Wrapper';
import * as styles from './styles.css';
import { BigTitle } from 'shared/components/BigTitle';
import { UTP } from './constants';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';
import { FourthUtpBlock } from 'shared/components/FourthUtpBlock';

export const FeatureService: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <Wrapper>
        <Element name={ENavigation.ServiceFeatures}>
          <Block>
            <BigTitle text="Особенности сервиса:" />
            <FourthUtpBlock utp={UTP} />
          </Block>
        </Element>
      </Wrapper>
    </div>
  );
};
